(function () {
  var PAGE_SIZE = 48;
  var DEFAULT_SORT = "best-selling";
  var PRODUCT_FITMENT_LIMIT = 10;
  var MAKE_SECTION_LIMIT = 999;
  var MODEL_SECTION_LIMIT = 999;
  window.TPS_SCOOTER_MODEL_DATA = window.TPS_SCOOTER_MODEL_DATA || {};
  window.TPS_SCOOTER_MAKE_DATA = window.TPS_SCOOTER_MAKE_DATA || {};
  var MODEL_DATA = window.TPS_SCOOTER_MODEL_DATA;
  var MAKE_DATA = window.TPS_SCOOTER_MAKE_DATA;
  var pendingModelLoads = {};
  var pendingMakeLoads = {};
  var SORT_OPTIONS = [
    ["manual", "Uitgelicht"],
    ["most-relevant", "Meest relevant"],
    ["best-selling", "Best verkopende"],
    ["title-ascending", "Alfabetisch: A-Z"],
    ["title-descending", "Alfabetisch: Z-A"],
    ["price-ascending", "Prijs: laag naar hoog"],
    ["price-descending", "Prijs: hoog naar laag"],
    ["created-ascending", "Datum: oud naar nieuw"],
    ["created-descending", "Datum: nieuw naar oud"],
  ];
  var DATA_ASSET_QUERY = "?codex=20260508v29data";

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function modelsPayload() {
    return window.TPS_SCOOTER_FITMENT_MODELS || { makes: [], modelsByLabel: {}, modelsBySlug: {} };
  }

  function normalizeLabel(value) {
    return String(value || "").trim().toLowerCase();
  }

  function normalizeSearch(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function alphaCompare(left, right, field) {
    return String((left || {})[field] || "").localeCompare(String((right || {})[field] || ""), "nl", {
      numeric: true,
      sensitivity: "base",
    });
  }

  function searchTokens(value) {
    var seen = {};
    return normalizeSearch(value)
      .split(/\s+/)
      .filter(Boolean)
      .filter(function (token) {
        if (seen[token]) return false;
        seen[token] = true;
        return true;
      });
  }

  function editDistanceAtMost(a, b, limit) {
    if (!a || !b) return false;
    if (Math.abs(a.length - b.length) > limit) return false;
    var prev = [];
    for (var j = 0; j <= b.length; j += 1) prev[j] = j;
    for (var i = 1; i <= a.length; i += 1) {
      var row = [i];
      var best = row[0];
      for (j = 1; j <= b.length; j += 1) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        row[j] = Math.min(prev[j] + 1, row[j - 1] + 1, prev[j - 1] + cost);
        if (row[j] < best) best = row[j];
      }
      if (best > limit) return false;
      prev = row;
    }
    return prev[b.length] <= limit;
  }

  function tokenMatchesWord(token, word) {
    if (!token || !word) return false;
    if (word.indexOf(token) >= 0) return true;
    if (token.length >= 4 && token.indexOf(word) >= 0) return true;
    if (token.length < 4 || word.length < 4) return false;
    return editDistanceAtMost(token, word, token.length >= 7 || word.length >= 7 ? 2 : 1);
  }

  function fuzzyScore(text, tokens) {
    if (!tokens.length) return 1;
    var normalized = normalizeSearch(text);
    if (!normalized) return 0;
    var words = normalized.split(/\s+/).filter(Boolean);
    var score = 0;
    for (var i = 0; i < tokens.length; i += 1) {
      var token = tokens[i];
      if (normalized.indexOf(token) >= 0) {
        score += 12;
        continue;
      }
      var matched = false;
      for (var j = 0; j < words.length; j += 1) {
        if (tokenMatchesWord(token, words[j])) {
          matched = true;
          score += 5;
          break;
        }
      }
      if (!matched) return 0;
    }
    return score;
  }

  function productSearchText(product) {
    return [
      product.sku,
      product.title,
      product.category,
      product.subcategory,
      (product.categories || []).join(" "),
    ].join(" ");
  }

  function productSearchScore(product, tokens) {
    if (!tokens.length) return 1;
    var score = fuzzyScore(productSearchText(product), tokens);
    if (!score) return 0;
    score += fuzzyScore(product.sku || "", tokens) * 4;
    score += fuzzyScore(product.title || "", tokens) * 2;
    return score;
  }

  function searchProducts(products, tokens) {
    if (!tokens.length) return products.slice();
    return products
      .map(function (product, index) {
        return { product: product, index: index, score: productSearchScore(product, tokens) };
      })
      .filter(function (row) {
        return row.score > 0;
      })
      .sort(function (a, b) {
        return b.score - a.score || a.index - b.index;
      })
      .map(function (row) {
        return row.product;
      });
  }

  function categoryCountsFromProducts(products) {
    var counts = {};
    products.forEach(function (product) {
      (product.categories || []).forEach(function (name) {
        if (!name) return;
        counts[name] = (counts[name] || 0) + 1;
      });
    });
    return Object.keys(counts)
      .map(function (name) {
        return { name: name, count: counts[name] };
      })
      .sort(function (a, b) {
        return alphaCompare(a, b, "name");
      });
  }

  function categoryGroupsFromProducts(products) {
    var groups = {};
    products.forEach(function (product) {
      var parentName = product.category || "Overig";
      var childName = product.subcategory && product.subcategory !== parentName ? product.subcategory : "";
      if (!groups[parentName]) groups[parentName] = { name: parentName, count: 0, children: {} };
      groups[parentName].count += 1;
      if (childName) groups[parentName].children[childName] = (groups[parentName].children[childName] || 0) + 1;
    });
    return Object.keys(groups)
      .map(function (name) {
        var group = groups[name];
        return {
          name: group.name,
          count: group.count,
          children: Object.keys(group.children)
            .map(function (childName) {
              return { name: childName, count: group.children[childName] };
            })
            .sort(function (a, b) {
              return alphaCompare(a, b, "name");
            }),
        };
      })
      .sort(function (a, b) {
        return alphaCompare(a, b, "name");
      });
  }

  function categoryDataFromProducts(products) {
    return {
      count: products.length,
      categories: categoryCountsFromProducts(products),
      categoryGroups: categoryGroupsFromProducts(products),
    };
  }

  function queryUrl(basePath, values) {
    var params = new URLSearchParams();
    Object.keys(values || {}).forEach(function (key) {
      var value = values[key];
      if (Array.isArray(value)) {
        value.forEach(function (item) {
          if (item !== undefined && item !== null && String(item).trim() !== "") {
            params.append(key, item);
          }
        });
        return;
      }
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        params.set(key, value);
      }
    });
    var query = params.toString();
    return query ? basePath + "?" + query : basePath;
  }

  function normalizeCategoryList(values) {
    var source = Array.isArray(values) ? values : [values];
    var seen = {};
    var result = [];
    source.forEach(function (value) {
      String(value == null ? "" : value)
        .split(",")
        .forEach(function (part) {
          var name = part.trim();
          if (!name || seen[name]) return;
          seen[name] = true;
          result.push(name);
        });
    });
    return result;
  }

  function categorySelected(categories, name) {
    return normalizeCategoryList(categories).indexOf(name) >= 0;
  }

  function toggleCategory(categories, name) {
    var current = normalizeCategoryList(categories);
    if (!name) return [];
    if (current.indexOf(name) >= 0) {
      return current.filter(function (item) {
        return item !== name;
      });
    }
    return current.concat(name);
  }

  function stateUrlValues(state) {
    var sort = normalizeSort(state && state.sort);
    return {
      pagina: state && state.page > 1 ? state.page : "",
      categorie: normalizeCategoryList(state && (state.categories || state.category)),
      zoek: state && state.searchQuery,
      op_voorraad: state && state.inStock ? "1" : "",
      sort_by: sort !== DEFAULT_SORT ? sort : "",
    };
  }

  function modelUrl(basePath, state) {
    return queryUrl(basePath, stateUrlValues(state || {}));
  }

  function categoryUrl(basePath, categories, category, searchQuery, inStock, sort) {
    return modelUrl(basePath, {
      categories: toggleCategory(categories, category),
      searchQuery: searchQuery,
      inStock: inStock,
      sort: sort,
      page: 1,
    });
  }

  function stockUrl(basePath, categories, searchQuery, inStock, sort) {
    return modelUrl(basePath, {
      categories: categories,
      searchQuery: searchQuery,
      inStock: !inStock,
      sort: sort,
      page: 1,
    });
  }

  function clearFiltersUrl(basePath, searchQuery, sort) {
    return modelUrl(basePath, {
      searchQuery: searchQuery,
      sort: sort,
      page: 1,
    });
  }

  function normalizeSort(value) {
    var sort = String(value || DEFAULT_SORT);
    var allowed = {
      manual: true,
      "most-relevant": true,
      "best-selling": true,
      "title-ascending": true,
      "title-descending": true,
      "price-ascending": true,
      "price-descending": true,
      "created-ascending": true,
      "created-descending": true,
    };
    return allowed[sort] ? sort : DEFAULT_SORT;
  }

  function sortLabel(value) {
    var sort = normalizeSort(value);
    for (var i = 0; i < SORT_OPTIONS.length; i += 1) {
      if (SORT_OPTIONS[i][0] === sort) return SORT_OPTIONS[i][1];
    }
    return "Best verkopende";
  }

  function renderSortOptions(current) {
    var sort = normalizeSort(current);
    return SORT_OPTIONS.map(function (option) {
      return '<option value="' + option[0] + '"' + (option[0] === sort ? " selected" : "") + ">" + escapeHtml(option[1]) + "</option>";
    }).join("");
  }

  function syncSortSelect(select) {
    if (!select) return;
    var label = sortLabel(select.value);
    var wrapper = select.closest(".select-wrapper") || select.parentElement;
    var current = wrapper ? wrapper.querySelector(".bv_atual .sl_inner") : null;
    if (current) current.textContent = label;
    if (wrapper) {
      wrapper.querySelectorAll(".bv_ul_inner .li").forEach(function (item) {
        var text = item.querySelector(".text");
        if (text) item.classList.toggle("bv_selected", text.textContent.trim() === label);
      });
    }
  }

  function priceValue(product) {
    var number = Number(String((product || {}).price || "").replace(",", "."));
    return Number.isFinite(number) ? number : 0;
  }

  function sortProducts(products, sort) {
    var mode = normalizeSort(sort);
    if (mode === "title-ascending") {
      return products.slice().sort(function (a, b) {
        return alphaCompare(a, b, "title");
      });
    }
    if (mode === "title-descending") {
      return products.slice().sort(function (a, b) {
        return alphaCompare(b, a, "title");
      });
    }
    if (mode === "price-ascending" || mode === "price-descending") {
      return products
        .map(function (product, index) {
          return { product: product, index: index, price: priceValue(product) };
        })
        .sort(function (a, b) {
          var diff = mode === "price-ascending" ? a.price - b.price : b.price - a.price;
          return diff || alphaCompare(a.product, b.product, "title") || a.index - b.index;
        })
        .map(function (row) {
          return row.product;
        });
    }
    return products.slice();
  }

  function knownModelFor(label) {
    var payload = modelsPayload();
    var exact = payload.modelsByLabel && payload.modelsByLabel[normalizeLabel(label)];
    if (exact) return exact;
    var wanted = normalizeLabel(label);
    if (!wanted) return null;
    var all = payload.models || [];
    for (var i = 0; i < all.length; i += 1) {
      var candidate = all[i];
      var known = normalizeLabel(candidate.label);
      if (wanted.indexOf(known) === 0) return candidate;
    }
    return null;
  }

  function pageUrlForModel(model) {
    return "/pages/scooter-" + model.slug;
  }

  function pageUrlForMake(make) {
    return "/pages/scooter-" + make.slug;
  }

  function countLabel(count, singular, plural) {
    return count + " " + (Number(count) === 1 ? singular : plural);
  }

  function makeLabel(make) {
    return (make && (make.displayName || make.label || make.name)) || "";
  }

  function formatPrice(value) {
    var number = Number(String(value || "").replace(",", "."));
    if (!Number.isFinite(number) || number <= 0) return "";
    return "\u20ac " + number.toFixed(2).replace(".", ",");
  }

  function stockLabel(product) {
    if (!product.variantId) return { text: "Bekijk product", className: "is-neutral" };
    if (!product.available) return { text: "Niet op voorraad", className: "is-out" };
    var qty = Number(product.availableQuantity || 0);
    if (qty > 0 && qty <= 5) return { text: "Nog " + qty + " op voorraad", className: "is-low" };
    return { text: "Op voorraad", className: "is-in" };
  }

  function assetBase(root) {
    return root.getAttribute("data-assets-base") || "";
  }

  function getModelData(slug) {
    return window.TPS_SCOOTER_MODEL_DATA && window.TPS_SCOOTER_MODEL_DATA[slug];
  }

  function getMakeData(slug) {
    return window.TPS_SCOOTER_MAKE_DATA && window.TPS_SCOOTER_MAKE_DATA[slug];
  }

  function loadModelData(root, slug) {
    var cached = getModelData(slug);
    if (cached) return Promise.resolve(cached);
    if (pendingModelLoads[slug]) return pendingModelLoads[slug];
    pendingModelLoads[slug] = new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.async = true;
      script.src = assetBase(root) + "tps-scooter-model-v23-" + slug + ".js" + DATA_ASSET_QUERY;
      script.onload = function () {
        var loaded = getModelData(slug);
        if (loaded) resolve(loaded);
        else reject(new Error("Modeldata niet gevonden: " + slug));
      };
      script.onerror = function () {
        reject(new Error("Modeldata kon niet laden: " + slug));
      };
      document.head.appendChild(script);
    });
    return pendingModelLoads[slug];
  }

  function loadMakeData(root, slug) {
    var cached = getMakeData(slug);
    if (cached) return Promise.resolve(cached);
    if (pendingMakeLoads[slug]) return pendingMakeLoads[slug];
    pendingMakeLoads[slug] = new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.async = true;
      script.src = assetBase(root) + "tps-scooter-make-v23-" + slug + ".js" + DATA_ASSET_QUERY;
      script.onload = function () {
        var loaded = getMakeData(slug);
        if (loaded) resolve(loaded);
        else reject(new Error("Merkdata niet gevonden: " + slug));
      };
      script.onerror = function () {
        reject(new Error("Merkdata kon niet laden: " + slug));
      };
      document.head.appendChild(script);
    });
    return pendingMakeLoads[slug];
  }

  window.TPS_REGISTER_SCOOTER_MODEL = function (payload) {
    if (!payload || !payload.slug) return;
    window.TPS_SCOOTER_MODEL_DATA = window.TPS_SCOOTER_MODEL_DATA || {};
    window.TPS_SCOOTER_MODEL_DATA[payload.slug] = payload;
    MODEL_DATA = window.TPS_SCOOTER_MODEL_DATA;
  };

  window.TPS_REGISTER_SCOOTER_MAKE = function (payload) {
    if (!payload || !payload.slug) return;
    window.TPS_SCOOTER_MAKE_DATA = window.TPS_SCOOTER_MAKE_DATA || {};
    window.TPS_SCOOTER_MAKE_DATA[payload.slug] = payload;
    MAKE_DATA = window.TPS_SCOOTER_MAKE_DATA;
  };

  function initProductFitment() {
    document.querySelectorAll("[data-tps-product-fitment]").forEach(function (root) {
      if (root.getAttribute("data-ready") === "1") return;
      root.setAttribute("data-ready", "1");
      var raw = root.getAttribute("data-models") || "[]";
      var labels = [];
      try {
        labels = JSON.parse(raw) || [];
      } catch (error) {
        labels = [];
      }
      var seen = {};
      var models = labels
        .map(knownModelFor)
        .filter(Boolean)
        .filter(function (model) {
          if (seen[model.slug]) return false;
          seen[model.slug] = true;
          return true;
        })
        .sort(function (a, b) {
          return alphaCompare(a, b, "label");
        });
      if (!models.length) {
        root.innerHTML = "";
        return;
      }
      var visibleModels = models.slice(0, PRODUCT_FITMENT_LIMIT);
      var extra = models.length - visibleModels.length;
      root.innerHTML =
        '<div class="tps-fitment__head">' +
        '<span class="tps-fitment__mark" aria-hidden="true">&#10003;</span>' +
        '<div><p class="tps-eyebrow">Scooter passing</p><h3>Past op deze scooters</h3>' +
        '<p class="tps-fitment__intro">Klik op je model en bekijk meteen alle passende onderdelen.</p></div>' +
        "</div>" +
        '<div class="tps-chip-row">' +
        visibleModels
          .map(function (model) {
            return '<a class="tps-chip" href="' + pageUrlForModel(model) + '">' + escapeHtml(model.label) + "</a>";
          })
          .join("") +
        (extra > 0 ? '<span class="tps-chip tps-chip--muted">+' + extra + " meer</span>" : "") +
        "</div>";
    });
  }

  function finderResultsHtml(makes, query) {
    var tokens = searchTokens(query);
    var makeRows = makes
      .map(function (make) {
        var label = makeLabel(make);
        return {
          type: "Merk",
          label: label,
          subtitle: countLabel(make.count || 0, "artikel", "artikelen"),
          url: pageUrlForMake(make),
          score: tokens.length ? fuzzyScore(label + " " + make.name, tokens) : 1,
        };
      })
      .filter(function (row) {
        return row.score > 0;
      })
      .sort(function (a, b) {
        return tokens.length ? b.score - a.score || alphaCompare(a, b, "label") : alphaCompare(a, b, "label");
      });
    var modelRows = [];
    if (tokens.length) {
      makes.forEach(function (make) {
        (make.models || []).forEach(function (model) {
          modelRows.push({
            type: makeLabel(make),
            label: model.label,
            subtitle: countLabel(model.count || 0, "artikel", "artikelen"),
            url: pageUrlForModel(model),
            score: fuzzyScore(model.label + " " + model.model + " " + make.name + " " + makeLabel(make), tokens),
          });
        });
      });
      modelRows = modelRows
        .filter(function (row) {
          return row.score > 0;
        })
        .sort(function (a, b) {
          return b.score - a.score || alphaCompare(a, b, "label");
        });
    }

    function section(title, rows, limit) {
      if (!rows.length) return "";
      var visibleRows = rows.slice(0, limit || rows.length);
      return (
        '<section class="tps-finder-result-section"><h3>' +
        escapeHtml(title) +
        "</h3>" +
        visibleRows
          .map(function (row) {
            return (
              '<a class="tps-finder-result" href="' +
              escapeHtml(row.url) +
              '"><span>' +
              escapeHtml(row.type) +
              "</span><strong>" +
              escapeHtml(row.label) +
              "</strong><em>" +
              escapeHtml(row.subtitle) +
              "</em></a>"
            );
          })
          .join("") +
        "</section>"
      );
    }

    var html =
      section(tokens.length ? "Merken" : "Alle merken", makeRows, tokens.length ? 18 : makeRows.length) +
      section("Modellen", modelRows, 18);
    return html || '<p class="tps-search-empty">Geen merk of model gevonden.</p>';
  }

  function renderFinderResults(root, makes) {
    var input = root.querySelector("[data-tps-finder-search]");
    var target = root.querySelector("[data-tps-finder-results]");
    if (!target) return;
    target.innerHTML = finderResultsHtml(makes, input ? input.value : "");
  }

  function renderFinder(root) {
    var payload = modelsPayload();
    var makes = (payload.makes || []).slice().sort(function (a, b) {
      return alphaCompare(a, b, "name");
    });
    root.innerHTML =
      '<header class="tps-scooter-page__hero tps-scooter-page__hero--finder">' +
      '<div class="tps-hero-copy"><p class="tps-eyebrow">Scooter onderdelen</p>' +
      "<h1>Vind onderdelen voor jouw scooter</h1>" +
      '<p class="tps-scooter-page__intro">Selecteer een merk of kies direct een model.</p></div>' +
      '<div class="tps-finder-shell">' +
      '<div class="tps-finder-picker">' +
      '<div class="tps-finder-controls">' +
      '<label>Merk<select data-tps-make><option value="">Kies merk</option>' +
      makes
        .map(function (make) {
          return '<option value="' + escapeHtml(make.name) + '">' + escapeHtml(makeLabel(make)) + " (" + make.count + ")</option>";
        })
        .join("") +
      "</select></label>" +
      '<label>Model<select data-tps-model disabled><option value="">Kies eerst merk</option></select></label>' +
      '<button type="button" data-tps-go disabled>Bekijk onderdelen</button>' +
      "</div>" +
      '<label class="tps-finder-search">Zoek merk of model<input type="search" data-tps-finder-search autocomplete="off" placeholder="Bijv. Puch, Tomos A35 of Aprilia SR"></label>' +
      "</div>" +
      '<aside class="tps-finder-results" data-tps-finder-results></aside>' +
      "</div></header>" +
      '<section class="tps-popular-models"><div class="tps-section-head"><h2>Scooter modellen per merk</h2><p>Kies je merk en model.</p></div>' +
      makes
        .slice(0, MAKE_SECTION_LIMIT)
        .map(function (make) {
          var makeModels = (make.models || []).slice().sort(function (a, b) {
            return alphaCompare(a, b, "model");
          });
          return (
            '<section class="tps-make-section"><h2>' +
            '<a href="' +
            pageUrlForMake(make) +
            '">' +
            escapeHtml(makeLabel(make)) +
            "</a>" +
            "</h2>" +
            '<div class="tps-model-grid">' +
            '<a class="tps-model-link tps-model-link--make" href="' +
            pageUrlForMake(make) +
            '"><strong>Alle ' +
            escapeHtml(makeLabel(make)) +
            "</strong><span>" +
            countLabel(make.count, "artikel", "artikelen") +
            "</span></a>" +
            makeModels
              .slice(0, MODEL_SECTION_LIMIT)
              .map(function (model) {
                return (
                  '<a class="tps-model-link" href="' +
                  pageUrlForModel(model) +
                  '"><strong>' +
                  escapeHtml(model.model) +
                  "</strong><span>" +
                  countLabel(model.count, "artikel", "artikelen") +
                  "</span></a>"
                );
              })
              .join("") +
            "</div></section>"
          );
        })
        .join("") +
      "</section>";

    var makeSelect = root.querySelector("[data-tps-make]");
    var modelSelect = root.querySelector("[data-tps-model]");
    var finderSearch = root.querySelector("[data-tps-finder-search]");
    var go = root.querySelector("[data-tps-go]");
    renderFinderResults(root, makes);
    makeSelect.addEventListener("change", function () {
      var make = makes.find(function (row) {
        return row.name === makeSelect.value;
      });
      var rows = make
        ? (make.models || []).slice().sort(function (a, b) {
            return alphaCompare(a, b, "model");
          })
        : [];
      modelSelect.innerHTML =
        '<option value="">' +
        (make ? "Alle " + escapeHtml(makeLabel(make)) + " onderdelen" : "Kies model") +
        "</option>" +
        rows
          .map(function (row) {
            return '<option value="' + escapeHtml(row.slug) + '">' + escapeHtml(row.model) + " (" + row.count + ")</option>";
          })
          .join("");
      modelSelect.disabled = !rows.length;
      go.disabled = !make;
    });
    modelSelect.addEventListener("change", function () {
      go.disabled = !makeSelect.value && !modelSelect.value;
    });
    finderSearch.addEventListener("input", function () {
      renderFinderResults(root, makes);
    });
    go.addEventListener("click", function () {
      if (modelSelect.value) {
        window.location.href = "/pages/scooter-" + modelSelect.value;
        return;
      }
      var make = makes.find(function (row) {
        return row.name === makeSelect.value;
      });
      if (make) window.location.href = pageUrlForMake(make);
    });
  }

  function productCard(product) {
    var title = product.title || product.sku || "";
    var url = product.url || "/search?type=product&q=" + encodeURIComponent(product.sku || title);
    var image = product.imageUrl
      ? '<picture><img src="' +
        escapeHtml(product.imageUrl) +
        '" alt="' +
        escapeHtml(title) +
        '" loading="lazy" width="430" height="430"></picture>'
      : "";
    var categoryDescription = product.subcategory && product.category && product.subcategory !== product.category ? product.category + " / " + product.subcategory : product.category || product.subcategory || "";
    var description = product.description || categoryDescription;
    var price = formatPrice(product.price).replace("\u20ac ", "\u20ac");
    var stock = stockLabel(product);
    return (
      '<li class="product-card has-form second-img-hover tps-theme-product-card' +
      (product.available ? "" : " unavailable") +
      '">' +
      '<figure class="img-multiply"><span class="s1lb label plain"></span><a href="' +
      escapeHtml(url) +
      '" aria-label="' +
      escapeHtml(title) +
      '">' +
      image +
      '</a><p class="link-btn wide mobile-hide"><a class="overlay-buy_button" href="' +
      escapeHtml(url) +
      '">Bekijk</a></p></figure>' +
      '<div><h3 class="p0"><a href="' +
      escapeHtml(url) +
      '">' +
      escapeHtml(title) +
      '</a></h3><input type="hidden" name="id" value="' +
      escapeHtml(product.variantId || "") +
      '"><p class="stock ' +
      (product.available ? "overlay-valid" : "overlay-error") +
      ' list-hide"><span>' +
      (product.available ? '<i aria-hidden="true" class="icon-check"></i> ' : "") +
      escapeHtml(stock.text) +
      "</span></p>" +
      (description ? '<div class="info"><p>' + escapeHtml(description) + "</p></div>" : "") +
      '</div><div class="static"><p class="stock ' +
      (product.available ? "overlay-valid" : "overlay-error") +
      ' list-only"><span>' +
      (product.available ? '<i aria-hidden="true" class="icon-check"></i> ' : "") +
      escapeHtml(stock.text) +
      "</span></p>" +
      (price ? '<p class="price s1pr">' + escapeHtml(price) + "</p>" : "") +
      '<p class="link-btn wide mobile-hide"><a class="overlay-buy_button" href="' +
      escapeHtml(url) +
      '">Bekijk</a></p></div></li>'
    );
  }

  function bindAddToCart(root) {
    root.querySelectorAll("[data-tps-add-to-cart]").forEach(function (button) {
      if (button.getAttribute("data-bound") === "1") return;
      button.setAttribute("data-bound", "1");
      button.addEventListener("click", function () {
        var variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;
        var oldText = button.textContent;
        button.disabled = true;
        button.textContent = "Toevoegen...";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Kon niet toevoegen");
            return response.json();
          })
          .then(function () {
            button.textContent = "Toegevoegd";
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            document.dispatchEvent(new CustomEvent("cart:updated"));
            window.dispatchEvent(new CustomEvent("cart:updated"));
            setTimeout(function () {
              button.disabled = false;
              button.textContent = oldText;
            }, 1800);
          })
          .catch(function () {
            window.location.href = "/cart/add?id=" + encodeURIComponent(variantId) + "&quantity=1";
          });
      });
    });
  }

  function paginationUrl(basePath, page, state) {
    return modelUrl(basePath, {
      categories: state.categories,
      searchQuery: state.searchQuery,
      inStock: state.inStock,
      sort: state.sort,
      page: page,
    });
  }

  function activeCategoryHtml(basePath, categories, searchQuery, inStock, sort) {
    var selected = normalizeCategoryList(categories);
    var items = [];
    if (inStock) {
      items.push(
        '<a class="tps-active-filter-clear" href="' +
          stockUrl(basePath, selected, searchQuery, true, sort) +
          '" data-tps-model-nav data-tps-clear-category>Op voorraad verwijderen</a>'
      );
    }
    selected.forEach(function (category) {
      items.push(
        '<a class="tps-active-filter-clear" href="' +
          categoryUrl(basePath, selected, category, searchQuery, inStock, sort) +
          '" data-tps-model-nav data-tps-clear-category>' +
          escapeHtml(category) +
          " verwijderen</a>"
      );
    });
    if (!items.length) return "";
    return (
      '<span>Actieve filters:</span>' +
      items.join("") +
      '<a class="tps-active-filter-clear" href="' +
      clearFiltersUrl(basePath, searchQuery, sort) +
      '" data-tps-model-nav data-tps-clear-category>Alles wissen</a>'
    );
  }

  function activeFilterLabel(categoryData, category) {
    var groups = (categoryData && categoryData.categoryGroups) || [];
    for (var index = 0; index < groups.length; index += 1) {
      var group = groups[index];
      if (group.name === category) return "Categorie";
      if (
        (group.children || []).some(function (child) {
          return child.name === category;
        })
      ) {
        return group.name;
      }
    }
    return "Onderdeelsoort";
  }

  function activeFilterListHtml(basePath, categories, searchQuery, inStock, sort, categoryData) {
    var selected = normalizeCategoryList(categories);
    var rows = [];
    if (inStock) {
      rows.push(
        '<li><label for="TPS-filter-availability-in-stock"><a href="' +
          stockUrl(basePath, selected, searchQuery, true, sort) +
          '" class="no-click" data-tps-model-nav><span>Beschikbaarheid</span> Op voorraad</a></label></li>'
      );
    }
    selected.forEach(function (category) {
      var label = activeFilterLabel(categoryData, category);
      rows.push(
        '<li><label for="' +
          escapeHtml(filterId(category)) +
          '"><a href="' +
          categoryUrl(basePath, selected, category, searchQuery, inStock, sort) +
          '" class="no-click" data-tps-model-nav><span>' +
          escapeHtml(label) +
          "</span> " +
          escapeHtml(category) +
          "</a></label></li>"
      );
    });
    if (!rows.length) return "";
    rows.push(
      '<li class="strong"><a href="' +
        clearFiltersUrl(basePath, searchQuery, sort) +
        '" class="remove-all" data-tps-model-nav data-tps-remove-all-filters>Verwijder alle filters</a></li>'
    );
    return rows.join("");
  }

  function hasActiveChild(group, categories) {
    if (categorySelected(categories, group.name)) return true;
    return (group.children || []).some(function (child) {
      return categorySelected(categories, child.name);
    });
  }

  function filterId(value) {
    return "TPS-filter-category-" + String(value || "alles").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }

  function nativeGroupHeader(id, label, open) {
    return (
      '<h4 data-filter-toggle="' +
      escapeHtml(id) +
      '" class="tps-native-filter-title' +
      (open ? " is-open" : "") +
      '"><a href="./" class="tps-native-filter-toggle" data-tps-native-toggle aria-expanded="' +
      (open ? "true" : "false") +
      '" aria-controls="' +
      escapeHtml(id) +
      '-list"><span>' +
      escapeHtml(label) +
      '</span><i aria-hidden="true" class="arrows_bv arrow down tps-native-filter-arrow"></i></a></h4>'
    );
  }

  function nativeCategoryOption(basePath, item, categories, searchQuery, inStock, sort, child) {
    var active = categorySelected(categories, item.name);
    var id = filterId(item.name);
    var className = "tps-category " + (child ? "tps-category--child" : "tps-category--parent") + (active ? " is-active" : "");
    return (
      '<li><input type="checkbox" name="categorie" value="' +
      escapeHtml(item.name) +
      '" id="' +
      escapeHtml(id) +
      '"' +
      (active ? " checked" : "") +
      '><label for="' +
      escapeHtml(id) +
      '" class="align-middle"><a href="' +
      categoryUrl(basePath, categories, item.name, searchQuery, inStock, sort) +
      '" class="' +
      className +
      '" data-tps-model-nav><span>' +
      escapeHtml(item.name) +
      " <span>(" +
      item.count +
      ")</span></span></a></label></li>"
    );
  }

  function nativeAvailabilityOption(basePath, categories, searchQuery, inStock, sort, count) {
    var id = "TPS-filter-availability-in-stock";
    return (
      '<li><input type="checkbox" name="op_voorraad" value="1" id="' +
      id +
      '"' +
      (inStock ? " checked" : "") +
      '><label for="' +
      id +
      '" class="strong"><a href="' +
      stockUrl(basePath, categories, searchQuery, inStock, sort) +
      '" class="tps-category tps-category--availability' +
      (inStock ? " is-active" : "") +
      '" data-tps-model-nav><span>Op voorraad <span>(' +
      count +
      ")</span></span></a></label></li>"
    );
  }

  function groupToggle(group, open) {
    var children = group.children || [];
    if (!children.length) return "";
    return (
      '<button type="button" class="tps-filter-group-toggle" data-tps-toggle-group aria-expanded="' +
      (open ? "true" : "false") +
      '" aria-label="Subcategorieen tonen of verbergen"><span>' +
      (open ? "-" : "+") +
      "</span></button>"
    );
  }

  function renderCategoryFilters(data, categories, basePath, searchQuery, inStock, sort, availableCount) {
    var groups = data.categoryGroups || [];
    if (groups.length) {
      return (
        nativeGroupHeader("TPS-filter-availability", "Beschikbaarheid", true) +
        '<ul class="check is-open" id="TPS-filter-availability-list" data-filter-toggle="TPS-filter-availability">' +
        nativeAvailabilityOption(basePath, categories, searchQuery, inStock, sort, availableCount) +
        "</ul>" +
        groups
          .map(function (group) {
            var id = filterId(group.name);
            var isActiveGroup = hasActiveChild(group, categories);
            var children = (group.children || [])
              .map(function (child) {
                return nativeCategoryOption(basePath, child, categories, searchQuery, inStock, sort, true);
              })
              .join("");
            return (
              nativeGroupHeader(id, group.name, isActiveGroup) +
              '<ul class="check' +
              (isActiveGroup ? " is-open" : " is-collapsed") +
              '" id="' +
              escapeHtml(id) +
              '-list" data-filter-toggle="' +
              escapeHtml(id) +
              '">' +
              nativeCategoryOption(basePath, group, categories, searchQuery, inStock, sort, false) +
              children +
              "</ul>"
            );
          })
          .join("")
      );
    }
    return (
      nativeGroupHeader("TPS-filter-availability", "Beschikbaarheid", true) +
      '<ul class="check is-open" id="TPS-filter-availability-list" data-filter-toggle="TPS-filter-availability">' +
      nativeAvailabilityOption(basePath, categories, searchQuery, inStock, sort, availableCount) +
      "</ul>" +
      nativeGroupHeader("TPS-filter-category-overig", "Onderdeelsoort", true) +
      '<ul class="check is-open" id="TPS-filter-category-overig-list" data-filter-toggle="TPS-filter-category-overig">' +
      (data.categories || [])
        .map(function (item) {
          return nativeCategoryOption(basePath, item, categories, searchQuery, inStock, sort, true);
        })
        .join("") +
      "</ul>"
    );
  }

  function toggleCategoryGroup(button) {
    if (button.hasAttribute("data-tps-native-toggle")) {
      var controls = button.getAttribute("aria-controls");
      var list = controls ? document.getElementById(controls) : null;
      if (!list) {
        var heading = button.closest("h4");
        list = heading && heading.nextElementSibling && heading.nextElementSibling.matches("ul.check") ? heading.nextElementSibling : null;
      }
      if (!list) return;
      var nativeOpen = list.classList.toggle("is-collapsed") ? false : true;
      list.classList.toggle("is-open", nativeOpen);
      button.setAttribute("aria-expanded", nativeOpen ? "true" : "false");
      var icon = button.querySelector("i");
      if (icon) {
        icon.textContent = "";
        icon.className = "arrows_bv arrow down tps-native-filter-arrow";
      }
      var nativeHeading = button.closest("h4");
      if (nativeHeading) nativeHeading.classList.toggle("is-open", nativeOpen);
      return;
    }
    var group = button.closest(".tps-filter-group");
    if (!group) return;
    var open = group.classList.toggle("is-open");
    button.setAttribute("aria-expanded", open ? "true" : "false");
    var label = button.querySelector("span");
    if (label) label.textContent = open ? "-" : "+";
  }

  function bindCategoryGroups(root) {
    root.querySelectorAll("[data-tps-toggle-group], [data-tps-native-toggle]").forEach(function (button) {
      if (button.getAttribute("data-bound") === "1") return;
      button.setAttribute("data-bound", "1");
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleCategoryGroup(button);
      });
    });
  }

  function modelStateFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var categories = normalizeCategoryList(params.getAll("categorie"));
    return {
      categories: categories,
      category: categories[0] || "",
      searchQuery: params.get("zoek") || "",
      inStock: params.get("op_voorraad") === "1",
      sort: normalizeSort(params.get("sort_by")),
      page: Math.max(1, Number(params.get("pagina") || "1")),
    };
  }

  function writeModelStateUrl(basePath, state, replace) {
    var url = modelUrl(basePath, state);
    if (replace) window.history.replaceState(null, "", url);
    else window.history.pushState(null, "", url);
  }

  function closeMobileFilter(root) {
    root.classList.remove("is-mobile-filter-open");
    document.body.classList.remove("tps-mobile-filter-active");
    document.documentElement.classList.remove("tps-mobile-filter-active");
    var openButton = root.querySelector("[data-tps-open-mobile-filters]");
    if (openButton) openButton.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }

  function scrollModelTop(root) {
    var target = root.querySelector(".tps-native-head") || root.querySelector(".tps-model-header") || root;
    window.requestAnimationFrame(function () {
      var top = target.getBoundingClientRect().top + window.pageYOffset - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    });
  }

  function bindModelSearch(root, data, basePath) {
    var form = root.querySelector("[data-tps-model-search]");
    if (!form || form.getAttribute("data-bound") === "1") return;
    form.setAttribute("data-bound", "1");
    var input = form.querySelector("[data-tps-model-search-input]");
    var timer = null;
    form.addEventListener("submit", function (event) {
      event.preventDefault();
    });
    if (!input) return;
    input.addEventListener("input", function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        var state = modelStateFromUrl();
        state.searchQuery = input.value;
        state.page = 1;
        writeModelStateUrl(basePath, state, true);
        renderModelState(root, data, basePath, state);
      }, 90);
    });
  }

  function bindCollectionToolbar(root, data, basePath) {
    var toolbar = root.querySelector(".tps-native-toolbar-form");
    if (toolbar && toolbar.getAttribute("data-bound") !== "1") {
      toolbar.setAttribute("data-bound", "1");
      toolbar.addEventListener("submit", function (event) {
        event.preventDefault();
      });
    }

    var sort = root.querySelector("[data-tps-sort]");
    if (sort && sort.getAttribute("data-bound") !== "1") {
      sort.setAttribute("data-bound", "1");
      sort.addEventListener("change", function () {
        var state = modelStateFromUrl();
        state.sort = normalizeSort(sort.value);
        state.page = 1;
        writeModelStateUrl(basePath, state, false);
        renderModelState(root, data, basePath, state);
      });
      syncSortSelect(sort);
    }

    root.querySelectorAll("[data-width]").forEach(function (input) {
      if (input.getAttribute("data-bound") === "1") return;
      input.setAttribute("data-bound", "1");
      input.addEventListener("change", function () {
        var grid = root.querySelector("[data-tps-product-grid]");
        if (!grid || !input.checked) return;
        grid.classList.remove("w20", "w25");
        grid.classList.add(input.getAttribute("data-width") || "w20");
      });
    });

    root.querySelectorAll("[data-tps-display]").forEach(function (link) {
      if (link.getAttribute("data-bound") === "1") return;
      link.setAttribute("data-bound", "1");
      link.addEventListener("click", function (event) {
        event.preventDefault();
        var list = link.getAttribute("data-tps-display") === "list";
        var grid = root.querySelector("[data-tps-product-grid]");
        root.classList.toggle("is-list-display", list);
        if (grid) grid.classList.toggle("list", list);
        root.querySelectorAll("[data-tps-display]").forEach(function (item) {
          var li = item.closest("li");
          if (li) li.classList.toggle("active", item === link);
        });
      });
    });
  }

  function bindModelNavigation(root, data, basePath) {
    if (root.getAttribute("data-model-nav-bound") === "1") return;
    root.setAttribute("data-model-nav-bound", "1");
    root.addEventListener("click", function (event) {
      var toggle = event.target.closest("[data-tps-toggle-group], [data-tps-native-toggle]");
      if (toggle && root.contains(toggle)) {
        event.preventDefault();
        event.stopPropagation();
        toggleCategoryGroup(toggle);
        return;
      }

      var clear = event.target.closest("[data-tps-clear-search]");
      if (clear && root.contains(clear)) {
        event.preventDefault();
        var input = root.querySelector("[data-tps-model-search-input]");
        var state = modelStateFromUrl();
        state.searchQuery = "";
        state.page = 1;
        if (input) input.value = "";
        writeModelStateUrl(basePath, state, true);
        renderModelState(root, data, basePath, state);
        if (input) input.focus();
        return;
      }

      var nativeInput = event.target.closest(".tps-native-fieldset input[type='checkbox'], .tps-native-fieldset label");
      if (nativeInput && root.contains(nativeInput)) {
        var nativeRow = nativeInput.closest("li");
        var nativeLink = nativeRow && nativeRow.querySelector("a[data-tps-model-nav]");
        if (nativeLink && !(event.target.closest && event.target.closest("a[data-tps-model-nav]"))) {
          event.preventDefault();
          event.stopPropagation();
          nativeLink.click();
          return;
        }
      }

      var link = event.target.closest("[data-tps-model-nav]");
      if (!link || !root.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      var shouldScrollTop = link.classList.contains("tps-page-link");
      var shouldCloseMobileFilter = link.hasAttribute("data-tps-close-after-nav");
      var url = new URL(link.href, window.location.origin);
      window.history.pushState(null, "", url.pathname + url.search);
      renderModelState(root, data, basePath, modelStateFromUrl());
      if (shouldScrollTop) scrollModelTop(root);
      if (shouldCloseMobileFilter) closeMobileFilter(root);
    });
    window.addEventListener("popstate", function () {
      renderModelState(root, data, basePath, modelStateFromUrl());
    });
  }

  function bindMobileFilterDrawer(root) {
    var openButton = root.querySelector("[data-tps-open-mobile-filters]");
    var closeButtons = root.querySelectorAll("[data-tps-close-mobile-filters]");
    if (!openButton || openButton.getAttribute("data-bound") === "1") return;
    openButton.setAttribute("data-bound", "1");

    function setOpen(open) {
      root.classList.toggle("is-mobile-filter-open", open);
      document.body.classList.toggle("tps-mobile-filter-active", open);
      document.documentElement.classList.toggle("tps-mobile-filter-active", open);
      openButton.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.style.overflow = open ? "hidden" : "";
    }

    openButton.addEventListener("click", function (event) {
      event.preventDefault();
      setOpen(true);
    });
    closeButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        setOpen(false);
      });
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && root.classList.contains("is-mobile-filter-open")) {
        setOpen(false);
      }
    });
  }

  function renderModelState(root, data, basePath, state) {
    var categories = normalizeCategoryList(state.categories || state.category);
    var searchQuery = state.searchQuery || "";
    var inStock = Boolean(state.inStock);
    var sort = normalizeSort(state.sort);
    var tokens = searchTokens(searchQuery);
    var page = Math.max(1, Number(state.page || 1));
    var searchedProducts = searchProducts(data.products || [], tokens);
    var availableCount = searchedProducts.filter(function (product) {
      return Boolean(product.available);
    }).length;
    var availabilityProducts = inStock
      ? searchedProducts.filter(function (product) {
          return Boolean(product.available);
        })
      : searchedProducts;
    var categoryData = categoryDataFromProducts(availabilityProducts);
    var products = availabilityProducts.filter(function (product) {
      if (!categories.length) return true;
      return categories.some(function (category) {
        return (product.categories || []).indexOf(category) >= 0;
      });
    });
    products = sortProducts(products, sort);
    var totalPages = Math.max(1, Math.ceil(products.length / PAGE_SIZE));
    if (page > totalPages) page = totalPages;
    var visible = products.slice(0, page * PAGE_SIZE);
    var start = visible.length ? 1 : 0;
    var end = visible.length;
    var stateForLinks = { categories: categories, searchQuery: searchQuery, inStock: inStock, sort: sort };
    var categoryLinks = renderCategoryFilters(categoryData, categories, basePath, searchQuery, inStock, sort, availableCount);
    var shownPercentage = products.length ? (end / products.length) * 100 : 0;
    var loadMore =
      page < totalPages
        ? '<p class="link-btn text-center"><a id="load-more-button" href="' +
          paginationUrl(basePath, page + 1, stateForLinks) +
          '" data-section="tps-scooter-fitment" data-next data-tps-model-nav data-tps-load-more>Toon meer producten</a></p>'
        : "";
    var searchNote = searchQuery ? " voor " + escapeHtml(searchQuery) : "";
    var activeLabels = categories.slice();
    if (inStock) activeLabels.unshift("Op voorraad");
    var mobileFilterLabel = activeLabels.length ? "Filters: " + escapeHtml(activeLabels.join(", ")) : "Filters";
    var activeCategory = activeCategoryHtml(basePath, categories, searchQuery, inStock, sort);
    var activeFilterList = activeFilterListHtml(basePath, categories, searchQuery, inStock, sort, categoryData);
    var hasActiveFilters = Boolean(activeFilterList);
    root.classList.toggle("has-active-filters", hasActiveFilters);

    var input = root.querySelector("[data-tps-model-search-input]");
    if (input && input.value !== searchQuery) input.value = searchQuery;

    var sortSelect = root.querySelector("[data-tps-sort]");
    if (sortSelect && sortSelect.value !== sort) sortSelect.value = sort;
    syncSortSelect(sortSelect);

    var summary = root.querySelector("[data-tps-model-summary]");
    if (summary) {
      summary.innerHTML =
        "<strong>" +
        products.length +
        "</strong> producten" +
        (categories.length ? " binnen " + escapeHtml(categories.join(", ")) : "") +
        (inStock ? " op voorraad" : "") +
        searchNote;
    }

    var toolbarCount = root.querySelector("[data-tps-toolbar-count]");
    if (toolbarCount) {
      toolbarCount.textContent = products.length + " producten";
    }

    var filterTotal = root.querySelector("[data-tps-filter-total]");
    if (filterTotal) {
      filterTotal.textContent = "(" + products.length + ")";
    }

    root.querySelectorAll("[data-tps-category-list]").forEach(function (list) {
      list.innerHTML = categoryLinks;
    });

    var currentFilters = root.querySelector("[data-tps-filter-current]");
    if (currentFilters) {
      currentFilters.innerHTML = activeFilterList;
      currentFilters.hidden = !hasActiveFilters;
    }

    root.querySelectorAll("[data-tps-remove-all-filters]").forEach(function (link) {
      link.setAttribute("href", clearFiltersUrl(basePath, searchQuery, sort));
      link.hidden = !hasActiveFilters;
    });

    var mobileActive = root.querySelector("[data-tps-mobile-active-filter]");
    if (mobileActive) {
      mobileActive.innerHTML = activeLabels.length
        ? '<span>' + mobileFilterLabel + '</span><a href="' + clearFiltersUrl(basePath, searchQuery, sort) + '" data-tps-model-nav data-tps-clear-category>Verwijderen</a>'
        : mobileFilterLabel;
    }

    var clearTarget = root.querySelector("[data-tps-search-clear-target]");
    if (clearTarget) {
      clearTarget.innerHTML = searchQuery
        ? '<a class="tps-search-clear" href="' +
          modelUrl(basePath, { categories: categories, searchQuery: "", inStock: inStock, sort: sort, page: 1 }) +
          '" data-tps-clear-search>Zoekopdracht wissen</a>'
        : "";
    }

    var activeTarget = root.querySelector("[data-tps-active-selection]");
    if (activeTarget) {
      activeTarget.innerHTML = activeCategory;
      activeTarget.hidden = !activeCategory;
    }

    var resultsHead = root.querySelector("[data-tps-results-head]");
    if (resultsHead) {
      resultsHead.innerHTML =
        "<p>Toont " +
        start +
        "-" +
        end +
        " van " +
        products.length +
        " artikelen" +
        (searchQuery ? " gevonden" : "") +
        "</p>";
    }

    var grid = root.querySelector("[data-tps-product-grid]");
    if (grid) {
      grid.innerHTML = visible.length ? visible.map(productCard).join("") : "<p>Geen artikelen gevonden binnen deze selectie.</p>";
    }

    var pagination = root.querySelector("[data-tps-pagination]");
    if (pagination) {
      pagination.innerHTML =
        '<div id="load-more-info" class="text-center"><p>Je hebt <span class="strong">' +
        end +
        '</span> van de <span class="strong">' +
        products.length +
        '</span> producten gezien</p><div><p class="s1br m20"><span class="rating-label"><span class="bar" style="width: ' +
        shownPercentage +
        '%"></span></span></p></div></div>' +
        loadMore;
    }

    bindCategoryGroups(root);
    bindAddToCart(root);
  }

  function renderModel(root, data) {
    var state = modelStateFromUrl();
    var basePath = "/pages/scooter-" + data.slug;
    var pageTitle = escapeHtml(data.label + " onderdelen");
    var sortOptions = renderSortOptions(state.sort);
    root.classList.add("is-native-layout");
    root.innerHTML =
      '<div class="shopify-section shopify-section-breadcrumbs tps-native-breadcrumb-section"><nav class="n6br" role="navigation" aria-label="breadcrumbs"><ol><li><a href="/" title="Home">Homepage</a></li><li><a href="/pages/scooter-onderdelen-op-model">Alle scooter modellen</a></li><li aria-current="page">' +
      pageTitle +
      "</li></ol></nav></div>" +
      '<div class="tps-mobile-filter-backdrop" data-tps-close-mobile-filters></div>' +
      '<div class="collection-wrapper m6cl sticky section-width-boxed tps-native-collection-wrapper">' +
      '<form action="' +
      basePath +
      '" method="get" class="f8fl tps-native-filter" id="filter"><fieldset class="tps-native-fieldset">' +
      '<legend>Filteren</legend><header><h3><span class="desktop-only tps-current-filter-title">Je huidige filters</span><span class="desktop-hide">Filteren</span><a href="' +
      clearFiltersUrl(basePath, state.searchQuery, state.sort) +
      '" class="desktop-hide remove-all" data-tps-model-nav data-tps-remove-all-filters>Verwijder alle filters</a><a class="header-toggle" href="#" data-tps-close-mobile-filters>Close</a></h3><ul class="desktop-only" data-tps-filter-current hidden></ul></header>' +
      '<div data-tps-category-list></div>' +
      '<p class="link-btn submit desktop-hide"><a href="./" aria-controls="filter" data-tps-close-mobile-filters>Toon producten <span data-tps-filter-total></span></a></p>' +
      "</fieldset></form>" +
      '<main class="tps-native-results">' +
      '<header class="tps-native-head"><h1>' +
      pageTitle +
      '</h1><p class="tps-theme-count" data-tps-model-summary hidden></p></header>' +
      '<form action="./" method="post" class="f8sr tps-native-toolbar-form"><fieldset><span class="hx" data-tps-toolbar-count></span><hr>' +
      '<p class="link-btn desktop-hide"><a href="#filter" class="f8fl-toggle" aria-controls="filter" data-tps-open-mobile-filters><i aria-hidden="true" class="icon-filter"></i> Filteren</a></p>' +
      '<ul class="l4in strong list-hide mobile-hide" aria-controls="collection"><li><input type="radio" id="fsc" name="fsa" data-width="w25"><label for="fsc"><span>4</span></label></li><li><input type="radio" id="fsd" name="fsa" data-width="w20" checked><label for="fsd"><span>5</span></label></li></ul>' +
      '<ul class="l4vw" aria-controls="collection"><li class="active"><a href="./" aria-label="Grid display" data-tps-display="grid"><i aria-hidden="true" class="icon-view-grid"></i><span class="hidden">Raster weergave</span></a></li><li><a href="./" aria-label="List display" data-tps-display="list"><i aria-hidden="true" class="icon-view-list"></i><span class="hidden">Lijst weergave</span></a></li></ul>' +
      '<p class="has-select done"><label for="sort_by">Sorteer op</label><span class="select-wrapper"><select id="sort_by" name="sort_by" data-tps-sort>' +
      sortOptions +
      "</select></span></p></fieldset></form>" +
      '<div class="tps-theme-toolbar"><div class="tps-results-head" data-tps-results-head></div></div>' +
      '<ul id="collection" class="l4cl w20 w50-mobile mobile-scroll" data-tps-product-grid></ul>' +
      '<div class="tps-pagination tps-native-load-more" data-tps-pagination></div></main></div>';

    bindModelSearch(root, data, basePath);
    bindCollectionToolbar(root, data, basePath);
    bindModelNavigation(root, data, basePath);
    bindMobileFilterDrawer(root);
    renderModelState(root, data, basePath, state);
  }

  function initPages() {
    document.querySelectorAll("[data-tps-scooter-page]").forEach(function (root) {
      if (root.getAttribute("data-ready") === "1") return;
      root.setAttribute("data-ready", "1");
      var mode = root.getAttribute("data-mode") || "finder";
      if (mode === "finder") {
        renderFinder(root);
        return;
      }
      var slug = root.getAttribute("data-model-slug") || "";
      if (!slug) {
        var handle = root.getAttribute("data-page-handle") || "";
        slug = handle.replace(/^scooter-/, "");
      }
      var payload = modelsPayload();
      var knownModel = payload.modelsBySlug && payload.modelsBySlug[slug];
      var knownMake = payload.makesBySlug && payload.makesBySlug[slug];
      var loader = knownModel ? loadModelData : knownMake ? loadMakeData : null;
      if (!loader) {
        root.innerHTML = '<div class="tps-error">Deze scooterpagina staat nog niet in de passing-index.</div>';
        return;
      }
      root.innerHTML = '<p class="tps-loading">Onderdelen laden...</p>';
      loader(root, slug)
        .then(function (data) {
          renderModel(root, data);
        })
        .catch(function (error) {
          root.innerHTML = '<div class="tps-error">' + escapeHtml(error.message) + "</div>";
        });
    });
  }

  function ready() {
    initProductFitment();
    initPages();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ready);
  else ready();
})();
